import { Typography } from "@material-ui/core";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import * as React from "react";
import { Formik } from "formik";
import { useEffect } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import AutoCompleteSearch from "../../components/dropdown/AutoCompleteSearch";
import SupplierUsersTable from "../../components/table/SupplierUsersTable";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import { GetCitiesResponse } from "../../models/basicInformation.model";
import { getTokenClaims } from "../../services/auth.service";
import { GetCities } from "../../services/basicInformation.service";
import ErrorPage from "../errorPage/errorPage";
import { object, string } from "yup";
import SideSwich from "../../components/switch/SideSwich";
import {
  AddSupplierUsersResponse,
  getSupplierUsersResponse,
} from "../../models/report.model";
import {
  AddSupplierUsers,
  GetSupplierUsers,
} from "../../services/report.service";
import AddBranchSkeleton from "./AddBranchSkeleton";
import ModalAddSupplierUsers from "../../components/modals/ModalAddSupplierUsers";

function AccessSupplierUsers() {
  const [openVerifyModal, setOpenVerifyModal] = React.useState(false);
  const [sendConfirmation, setSendConfirmation] = React.useState();
  const [isAddUserShowed, setShowAddUser] = React.useState(false);
  const [showAddUserForm, setshowAddUserForm] = React.useState(true);

  const [supplierUsers, setSupplierUsers] = React.useState<
    getSupplierUsersResponse[]
  >([]);
  const [cityIds, setCityIds] = React.useState<number>(0);

  const usersValidation = object().shape({
    userFirstname: string()
      .ensure()
      .required("لطفا نام را وارد نمایید.")
      .matches(/^(?!\s+$).*/, "لطفا نام را صحیح وارد نمایید")
      .max(250, "نام نباید بیشتر از ۲۵۰ باشد"),
    userLastname: string()
      .ensure()
      .matches(/^(?!\s+$).*/, "لطفا نام خانوادگی را صحیح وارد نمایید")
      .required("لطفا نام خانوادگی را وارد نمایید.")
      .max(250, "نام خانوادگی نباید بیشتر از ۲۵۰ باشد"),

    mobileNo: string()
      .ensure()
      .required("لطفا شماره موبایل را وارد نمایید.")
      .matches(
        /^(\+98|0098|98|0)?9\d{9}$/,
        "لطفا شماره موبایل را صحیح وارد نمایید"
      ),
    // nationalCode: string().ensure(),
    // .required("لطفا کد ملی را وارد نمایید")
  });

  let initialValues: any = {
    userFirstname: "",
    userLastname: "",
    mobileNo: "",
    city: "",
    nationalCode: null,
  };

  const history = useHistory<any>();

  const [cities, setCities] = React.useState<GetCitiesResponse[]>([]);
  const [city, setCity] = React.useState<any>();
  const [supplierNewUser, setSupplierNewUser] = React.useState<
    AddSupplierUsersResponse
  >();

  const [reloadOnEdit, setReoadOnEdit] = React.useState();
  const [reloadOnDel, setReoadOnDel] = React.useState();

  const id = window.localStorage.getItem("SUPPLIER_ID");

  const { mutate: getCitiesMutate } = useMutation(GetCities, {
    onSuccess: (data: GetCitiesResponse[]) => {
      if (data) {
        setCities(data);
      }
    },
    onError: () => { },
  });

  const { isLoading, mutate: GetSupplierUsersMutate } = useMutation(
    GetSupplierUsers,
    {
      onSuccess: (data: getSupplierUsersResponse[]) => {
        if (data) {
          setSupplierUsers(data);
        }
      },
      onError: () => { },
    }
  );

  const { mutate: AddSupplierUsersMutate } = useMutation(AddSupplierUsers, {
    onSuccess: (data: AddSupplierUsersResponse) => {
      if (data) {
        setSupplierNewUser(data);
        GetSupplierUsersMutate({
          supplierId: Number(id!),
        });
        setshowAddUserForm(false);
      }
    },
    onError: () => { },
  });

  useEffect(() => {
    if (history.action === "POP") {
      history.push({
        pathname: "/setting/supplierUsers",
        state: { id: JSON.parse(localStorage.getItem("SUPPLIER_ID")!) },
      });
    }
  }, [history, id]);
  useEffect(() => {
    GetSupplierUsersMutate({
      supplierId: Number(id!),
    });
  }, [sendConfirmation])

  const handleAddUser = (values: any) => {
    if (!values.isActive) {
      values.isActive = false;
    }
    values.cityTitle = city;
    values.city = cityIds;

    AddSupplierUsersMutate({
      firstName: values.userFirstname.trim(),
      lastName: values.userLastname.trim(),
      mobileNumber: values.mobileNo,
      // nationalCode: values.nationalCode,
      cityId: values.city,
      isSuperUser: values.isActive,
      supplierId: Number(id!),
    });
  };

  function changeCityIds(e: any, value: any) {
    setCityIds(e);
    setCity(value);
  }

  useEffect(() => {
    getCitiesMutate({});
  }, []);

  useEffect(() => {
    if (id !== undefined) {
      GetSupplierUsersMutate({
        supplierId: Number(id),
      });
    }
  }, [reloadOnEdit, reloadOnDel]);

  return (
    <>
      <Box
        width={"100%"}
        height={"85vh"}
        border={"1.5px solid #DAE0E4"}
        borderRadius={"5px"}
        padding={"2rem"}
      >
        <Typography
          style={{
            color: "#1D4A87",
            fontSize: "18px",
            width: "fit-content",
            marginTop: "-40px",
            marginRight: "23px",
            background: "#fff",
          }}
        >
          اطلاعات کاربران
        </Typography>
        {isLoading ? (
          <AddBranchSkeleton />
        ) : (
          <>
            {/* no user added */}

            {supplierUsers.length === 0 && !isAddUserShowed && (
              <Grid
                container
                alignItems="center"
                justifyContent={"center"}
                width={"100%"}
                height={"100%"}
                flexDirection={"column"}
                gap={"2rem"}
              >
                <Grid item marginBottom={"10px"}>
                  <div>
                    <img
                      src="/images/nouser.jpg"
                      alt="no user"
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                  <Typography style={{ color: "#9AAFC4", fontSize: "20px" }}>
                    کاربری ثبت نشده است
                  </Typography>
                </Grid>
                <Grid item>
                  <Button
                    sx={{
                      width: "fitContent",
                      background: "#28A745",
                      color: "#fff",
                      padding: ".7rem 2rem",
                      fontSize: "14px",
                    }}
                    className="btnForm SuccessDefault"
                    onClick={() => setOpenVerifyModal(true)}
                  >
                    افزودن کاربر جدید
                  </Button>
                </Grid>
              </Grid>
            )}

            {/* add user */}
            {(supplierUsers.length !== 0 || isAddUserShowed) && (
              <>
                <div
                  style={{
                    padding: "1rem 2rem",
                    marginBottom: "20px",
                    marginTop: "10px",
                  }}
                >
                  <AddCircleOutlineIcon
                    className="cursorPointer SuccessDefaultFont"
                    style={{ width: "25px", height: "25px" }}
                    onClick={() => setOpenVerifyModal((prev) => !prev)}
                  />
                  <span
                    className="cursorPointer SuccessDefaultFont"
                    style={{ marginRight: "10px", fontWeight: "bold" }}
                    onClick={() => setOpenVerifyModal((prev) => !prev)}
                  >
                    ثبت کاربر جدید
                  </span>
                </div>

                {/* {showAddUserForm && (
                  <Box
                    width={"100%"}
                    // height={"85vh"}
                    border={"1.5px solid #DAE0E4"}
                    borderRadius={"5px"}
                    boxShadow={"1px 1px lightgray"}
                  >
                    <Typography
                      style={{
                        color: "#1D4A87",
                        fontSize: "18px",
                        width: "fit-content",
                        marginTop: "-23px",
                        marginRight: "23px",
                        background: "#fff",
                      }}
                    >
                      افزودن اطلاعات کاربر
                    </Typography>

                    {
                      <Formik
                        initialValues={initialValues}
                        onSubmit={handleAddUser}
                        validateOnMount={true}
                        validationSchema={usersValidation}
                      >
                        {({
                          handleSubmit,
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                        }) => (
                          <form
                            onSubmit={handleSubmit}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                              }
                            }}
                          >
                            <Grid
                              container
                              columns={14}
                              gap={1}
                              justifyContent={{
                                xs: "center",
                                sm: "center",
                                md: "center",
                                lg: "space-between",
                              }}
                              alignItems={"center"}
                              padding={"0 1rem"}
                              minHeight={"100px"}
                            >
                              <Grid item xs={12} sm={6} md={6} lg={2} xl={2}>
                                <MaterialTextFieldComponent
                                  placeHolder={"نام"}
                                  label={"نام"}
                                  required={true}
                                  name={"userFirstname"}
                                  id={"userFirstname"}
                                  value={values.userFirstname}
                                  onChange={handleChange}
                                  helperText={
                                    touched.userFirstname
                                      ? errors.userFirstname
                                      : ""
                                  }
                                  error={
                                    touched.userFirstname &&
                                    Boolean(errors.userFirstname)
                                  }
                                  onBlur={handleBlur}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} md={6} lg={2} xl={2}>
                                <MaterialTextFieldComponent
                                  placeHolder={"نام خانوادگی"}
                                  label={"نام خانوادگی"}
                                  required={true}
                                  name={"userLastname"}
                                  id={"userLastname"}
                                  value={values.userLastname}
                                  onChange={handleChange}
                                  helperText={
                                    touched.userLastname
                                      ? errors.userLastname
                                      : ""
                                  }
                                  error={
                                    touched.userLastname &&
                                    Boolean(errors.userLastname)
                                  }
                                  onBlur={handleBlur}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} md={6} lg={2} xl={2}>
                                <MaterialTextFieldComponent
                                  placeHolder={"شماره موبایل"}
                                  label={"شماره موبایل"}
                                  required={true}
                                  name={"mobileNo"}
                                  id={"mobileNo"}
                                  inputProps={{ maxLength: 11 }}
                                  value={values.mobileNo}
                                  onChange={handleChange}
                                  helperText={
                                    touched.mobileNo ? errors.mobileNo : ""
                                  }
                                  error={
                                    touched.mobileNo && Boolean(errors.mobileNo)
                                  }
                                  onBlur={handleBlur}
                                  onKeyDown={(event) => {
                                    if (event.code === "Space") {
                                      event.preventDefault();
                                    }
                                  }}
                                />
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={6}
                                md={6}
                                lg={2}
                                xl={2}
                                className="supp-users-search"
                              >
                                <AutoCompleteSearch
                                  label={"استان و شهر محل فعالیت"}
                                  name={`city`}
                                  id={`city`}
                                  value={cityIds}
                                  options={cities}
                                  onChange={changeCityIds}
                                  responseValue={city}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} md={6} lg={2} xl={2}>
                                <SideSwich
                                  Label={"سطح دسترسی"}
                                  checked={values.isActive || false}
                                  onChange={(checked: boolean = false) => {
                                    values.isActive = checked;
                                  }}
                                  onlabel={"کامل"}
                                  offlabel={"محدود"}
                                />
                              </Grid>

                              <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                                <Grid
                                  container
                                  justifyContent={"center"}
                                  alignItems={"center"}
                                  gap={1}
                                  marginBottom={"8px"}
                                >
                                  <Grid item xs={5} width={"100%"}>
                                    <Button
                                      fullWidth
                                      type="submit"
                                      variant="contained"
                                      sx={{ borderRadius: "5px !important" }}
                                      disabled={
                                        !values.userFirstname ||
                                        !values.userLastname ||
                                        !values.mobileNo ||
                                        !cityIds
                                      }
                                      className={
                                        !values.userFirstname ||
                                        !values.userLastname ||
                                        !values.mobileNo ||
                                        !cityIds
                                          ? "btnForm disabledBtn"
                                          : "btnForm SuccessDefault"
                                      }
                                    >
                                      افزودن
                                    </Button>
                                  </Grid>
                                  <Grid item xs={5} width={"100%"}>
                                    <Button
                                      fullWidth
                                      variant="contained"
                                      style={{
                                        fontSize: "1rem",
                                        color: "#fff",
                                        height: "40px",
                                        background: "#607D8B",
                                      }}
                                      sx={{ borderRadius: "5px !important" }}
                                      onClick={() => setshowAddUserForm(false)}
                                    >
                                      انصراف
                                    </Button>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </form>
                        )}
                      </Formik>
                    }
                  </Box>
                )} */}
                <ModalAddSupplierUsers
                  openModel={openVerifyModal}
                  setSendConfirmation={setSendConfirmation}
                  setOpenVerifyModal={setOpenVerifyModal}
                />
              </>
            )}

            {/* users table */}
            {supplierUsers.length > 0 && (
              <Box
                sx={{
                  marginTop: "20px",
                  height: "55vh",
                  overflowY: "auto",
                  paddingX: "1px",
                }}
              >
                <Table
                  sx={{ minWidth: { xs: 0, sm: 0, md: 700, lg: 900 } }}
                  aria-label="customized table"
                >
                  <TableBody sx={{ outline: "1px solid #DAE0E4" }}>
                    {supplierUsers?.length !== 0 &&
                      supplierUsers
                        ?.map((user) => (
                          <SupplierUsersTable
                            city={user.city}
                            userFirstname={user.firstName}
                            userLastname={user.lastName}
                            superUser={user.isSuperUser}
                            mobileNo={user.mobileNumber}
                            active={user.isActive}
                            citiesList={cities}
                            supplierId={id!}
                            userId={user.id}
                            setReloadOnEdit={setReoadOnEdit}
                            setReloadOnDel={setReoadOnDel}
                            cityId={user.cityId}
                          />
                        ))
                        .reverse()}
                  </TableBody>
                </Table>
              </Box>
            )}
          </>
        )}
      </Box>
    </>
  );
}
export default function SupplierUsers() {
  const canModifyUser = String(getTokenClaims()?.canModifyUser);
  return (
    <> {canModifyUser !== "True" ? <AccessSupplierUsers /> : <ErrorPage />}</>
  );
}
